import API from "./api";

let callStatusCache = {
  labels: null,
  statuses: null,
  loading: false,
  promise: null,
};

/**
 * Load call status labels and cache them
 * Returns a promise that resolves with { callStatusLabels, callStatuses }
 */
export const loadCallStatusLabels = async () => {
  // Return cached data if already loaded
  if (callStatusCache.labels && callStatusCache.statuses) {
    return {
      callStatusLabels: callStatusCache.labels,
      callStatuses: callStatusCache.statuses,
    };
  }

  // If already loading, return the same promise
  if (callStatusCache.promise) {
    return callStatusCache.promise;
  }

  // Fetch and cache
  callStatusCache.promise = (async () => {
    try {
      const res = await API.get("/call-status-labels");
      const data = res.data.data || res.data;
      callStatusCache.labels = data.callStatusLabels || {};
      callStatusCache.statuses = data.callStatuses || [];
      return {
        callStatusLabels: callStatusCache.labels,
        callStatuses: callStatusCache.statuses,
      };
    } catch (e) {
      console.error("Failed to load call status labels", e);
      callStatusCache.promise = null; // Reset on error
      return {
        callStatusLabels: {},
        callStatuses: [],
      };
    }
  })();

  return callStatusCache.promise;
};

/**
 * Get the cached call status labels (must call loadCallStatusLabels first)
 */
export const getCallStatusLabels = () => {
  return callStatusCache.labels || {};
};

/**
 * Get the label for a single call status
 */
export const getCallStatusLabel = (statusCode) => {
  const labels = callStatusCache.labels || {};
  return labels[statusCode] || String(statusCode);
};
